<template>
    <div class="page page-container">
        <!-- ABA CONFIGURAÇÕES -->
        <div class="form-config registry-wrapper">
            <!-- MULTIPLICADOR -->
            <template v-if="permissao.update">
                <div class="mult-edit">
                    <div class="venda-input">
                        <label v-text="$t('mult-venda')" />
                        <input
                            type="number"
                            step="0.01"
                            min="0"
                            v-model="config.mult_edit.venda"
                            :disabled="
                                config.disableInputsMultiplicador ||
                                config.mult_selected == null ||
                                hasError
                            "
                        />
                    </div>
                    <div class="troca-input">
                        <label v-text="$t('mult-troca')" />
                        <input
                            type="number"
                            step="0.01"
                            min="0"
                            v-model="config.mult_edit.troca"
                            :disabled="
                                config.disableInputsMultiplicador ||
                                config.mult_selected == null ||
                                hasError
                            "
                        />
                    </div>
                    <div class="empresa-input">
                        <label v-text="$t('empresa')" />
                        <v-select
                            ref="config-vendedorInput"
                            class="no-clear"
                            label="nome"
                            v-model="config.mult_edit.empresa"
                            :options="config.empresas"
                            :loading="config.empresasLoading"
                            :disabled="
                                config.disableInputsMultiplicador ||
                                config.mult_selected == null ||
                                hasError
                            "
                            @search="loadVendedores"
                        >
                            <template slot="no-options">{{
                                $t('sem-resultados-filtro')
                            }}</template>
                        </v-select>
                    </div>
                    <div class="add-button">
                        <button
                            class="button btn-add-small"
                            @click="salvarMultiplicador"
                            :disabled="
                                config.disableInputsMultiplicador ||
                                config.mult_selected == null ||
                                hasError
                            "
                        >
                            {{ $t('salvar') }}
                        </button>
                        <button
                            class="button btn-del-small"
                            @click="cancelMultiplicador"
                            :disabled="config.disableInputsMultiplicador || hasError"
                        >
                            {{ $t('cancelar') }}
                        </button>
                    </div>
                    <h3 v-if="bloqueiaMultiplicadorERP">
                        {{ $t('informacao-multiplicador-integracao') }}
                    </h3>
                </div>
            </template>

            <!-- TABELA -->
            <empty-table-message
                class="config-empty"
                v-if="(config.mult_data && !config.mult_data.length) || hasError"
                msg="msg-nodata-multiplicadores"
            />
            <b-table
                v-else
                class="data-table"
                :data="hasError ? [] : config.mult_data"
                :selected="config.mult_selected"
            >
                <b-table-column
                    v-for="(u, i) in config.mult_fields"
                    :key="i"
                    :field="u.key"
                    :label="u.key != 'actions' ? $t(u.label) : ''"
                    :width="u.width"
                    :class="u.key != 'actions' ? 'td-cell' : 'excluir-field'"
                    :sortable="u.sortable"
                    v-slot="props"
                >
                    <div v-if="u.key == 'actions'" style="min-width: 100px">
                        <b-button
                            v-if="permissao.update"
                            @click="editMultiplicador(props.row)"
                            icon-right="pencil"
                            position="is-left"
                            :disabled="config.disableInputsMultiplicador || hasError"
                            v-tippy 
                            :title="$t('editar')"
                        />

                        <b-button
                            v-if="permissao.delete"
                            class="ml-1"
                            type="is-danger"
                            @click="
                                confirmExclusion(
                                    props.row,
                                    excluirMultiplicador,
                                    'msg-del-multiplicador'
                                )
                            "
                            icon-right="delete"
                            position="is-left"
                            :disabled="config.disableInputsMultiplicador || hasError"
                            v-tippy 
                            :title="$t('excluir')"
                        />
                    </div>
                    <div v-else-if="u.key == 'empresa'">
                        {{ props.row.empresa.nome }}
                    </div>
                    <div
                        v-else-if="u.key == 'multiplicadorweb' || u.key == 'multiplicadortrocaweb'"
                    >
                        {{ getDecimal(props.row[u.key]) }}
                    </div>
                </b-table-column>
            </b-table>
        </div>
    </div>
</template>

<script>
import VenProdutoService from '@/services/vendas/produto/VenProdutoService';
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import VenProdutoValidation from '@/services/validations/VenProdutoValidation';
import Message from '@/models/Message';

export default {
    components: {

    },
    data() {
        return {
            service: null,
            empresaService: null,
            validation: null,
            idpedido: 0,
            config: {
                // Multiplicadores
                mult_data: null,
                mult_fields: [
                    { key: 'empresa', label: 'empresa', sortable: false },
                    { key: 'multiplicadorweb', label: 'mult-venda', sortable: false },
                    {
                        key: 'multiplicadortrocaweb',
                        label: 'mult-troca',
                        sortable: false,
                    },
                    { key: 'actions', label: '', width: 70, sortable: false },
                ],
                mult_selected: null,
                mult_edit: {
                    idassprodutoempresa: null,
                    venda: '',
                    troca: '',
                    empresa: null,
                },
                empresas: [],
                empresasLoading: false,
                disableInputsMultiplicador: false,
            },
            hasError: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-politica-comercial-multiplo'
        );

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'multiplo' },
            });

        this.service = new VenProdutoService(this.$http, this.$router);
        this.empresaService = new EmpresaService(this.$http, this.$router);
        this.validation = new VenProdutoValidation(this.msgs);

        this.idproduto = this.$route.params.id;
        this.loadTabConfig();
    },
    methods: {
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        loadTabConfig() {
            this.service
                .loadConfig(this.idproduto)
                .then((r) => {
                    if (r.status != 200) {
                        this.showMessage('error', 'msg-erro-config');
                        this.hasError = true;
                    } else {
                        this.config.mult_data = r.content.multiplicadores;

                        this.loadVendedores('');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar configurações.', e);
                    this.showMessage('error', 'msg-erro-config');
                    this.hasError = true;
                })
                .finally(() => {
                    this.loadingTab = false;
                });
        },
        editMultiplicador(row) {
            if (
                (row.multiplicador != 0 && row.multiplicador != 1) ||
                (row.multiplicadortroca != 0 && row.multiplicadortroca != 1)
            ) {
                this.bloqueiaMultiplicadorERP = true;
            } else {
                this.bloqueiaMultiplicadorERP = false;
                this.config.mult_selected = row;
                this.config.mult_edit.venda = row.multiplicadorweb;
                this.config.mult_edit.troca = row.multiplicadortrocaweb;
                this.config.mult_edit.empresa = row.empresa;
            }
        },
        cancelMultiplicador() {
            this.bloqueiaMultiplicadorERP = false;
            this.config.mult_selected = null;
            this.config.mult_edit.venda = '';
            this.config.mult_edit.troca = '';
            this.config.mult_edit.empresa = null;
        },
        loadMultiplicador() {
            this.config.disableInputsMultiplicador = true;

            this.service
                .loadMultiplicadores(this.$route.params.id)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro ${r.status} ao carregar a tabela de associação de produto com empresa.`
                        );
                        this.config.mult_data = [];
                    } else {
                        this.config.mult_data = r.content;
                    }
                })
                .catch((e) => {
                    console.error(
                        'Erro ao carregar a tabela de associação de produto com empresa.',
                        e
                    );
                    this.config.mult_data = [];
                })
                .finally(() => {
                    this.config.disableInputsMultiplicador = false;
                });
        },
        salvarMultiplicador() {
            if (this.validation.validateNovoMultiplicador(this.config.mult_edit)) {
                let mult = {};

                this.config.disableInputsMultiplicador = true;

                if (this.config.mult_selected != null) {
                    mult = this.config.mult_selected;
                } else {
                    mult.idassprodutoempresa = null;
                }

                mult.multiplicadorweb = this.config.mult_edit.venda;
                mult.multiplicadortrocaweb = this.config.mult_edit.troca;
                mult.idempresa = this.config.mult_edit.empresa.id;

                this.service
                    .saveMultiplicador(mult)
                    .then((r) => {
                        if (r.status != 200) {
                            console.error(`Erro ${r.status} ao salvar desconto por quantidade.`);
                            this.showMessage('error', 'msg-erro-add-mult-save');
                        } else {
                            this.showMessage('success', 'msg-success-add-mult-save');
                        }
                    })
                    .catch((e) => {
                        console.error('Erro ao adicionar multiplicador', e);
                        this.showMessage('error', 'msg-erro-add-mult-save');
                    })
                    .finally(() => {
                        this.cancelMultiplicador();
                        this.config.disableInputsMultiplicador = false;
                        this.loadMultiplicador();
                    });
            }
        },
        excluirMultiplicador(mult) {
            this.service
                .delMultiplicador(mult.idassprodutoempresa)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`Erro ${r.status} ao salvar desconto por quantidade.`);
                        this.showMessage('error', 'msg-erro-del-mult');
                    } else {
                        this.showMessage('success', 'msg-success-del-mult');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao salvar desconto por quantidade', e);
                    this.showMessage('error', 'msg-erro-del-mult');
                })
                .finally(() => {
                    // Reabilitar a entrada
                    this.config.disableInputsMultiplicador = false;
                    this.loadMultiplicador();
                });
        },
        loadVendedores(q) {
            this.config.empresasLoading = true;

            this.empresaService
                .findAllOld(0, 20, q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro com status ${r.status} ao realizar pesquisa por empresa. Termo: [${q}].`
                        );
                        this.config.empresas = [];
                    } else {
                        this.config.empresas = r.content.map((v) => {
                            return {
                                id: v.id,
                                nome: v.nome.toLocaleUpperCase(),
                            };
                        });
                        this.config.empresas.unshift({
                            id: 0,
                            nome: 'todas',
                        });
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa por empresa. Termo: [${q}].`, e);
                    this.config.empresas = [];
                })
                .finally(() => {
                    this.config.empresasLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
$padding: 5px;

@mixin smallbtn() {
    height: 36px;
    font-size: 12px;
    color: $sovis-white;
    @include gradient-button();
}

input {
    color: $darker-gray-color;
}

button {
    &.btn-add-small {
        @include smallbtn();
    }

    &.btn-del-small {
        @include smallbtn();
        @include exclude-button();
        color: $darker-gray-color;
    }
}

#main .page.page-container {
    padding: 5px 20px;
}

.page {
    > h1.title {
        padding-top: 20px;
        margin-bottom: 0px;
        margin-right: 0;
    }

    .data-table .table-empty {
        border: 1px solid $table-border;
        border-radius: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        flex-wrap: wrap;
        font-weight: 600;
        height: 100px;

        div {
            display: flex;
            justify-content: center;
            width: 100%;
        }
    }

    .form-config {
        height: 100%;
        margin-bottom: 20px;

        .data-table {
            margin-top: 5px;
        }

        .lote {
            margin-top: 15px;
        }

        .mult-edit {
            display: flex;
            margin-top: 10px;

            .venda-input,
            .troca-input,
            .empresa-input,
            .tabpreco-input {
                width: calc((100% / 4) - #{$padding}/ 2);
            }

            .tabpreco-input {
                width: calc(100% - 150px - #{$padding});
            }

            .add-button {
                display: flex;
                align-items: flex-end;
                margin-left: 5px;

                button {
                    margin-left: 0px;
                }

                button:not(:first-child) {
                    margin-left: 5px;
                }
            }
        }

        .desc-qtd-edit {
            flex-wrap: wrap;
            justify-content: space-between;

            .add-button {
                width: 150px;

                button {
                    display: flex;
                    flex-grow: 1;
                }
            }
        }

        .config-empty,
        .data-table {
            min-height: 150px;
        }
    }
}

@media only screen and (max-width: 760px) {
    .page {
        .form-config {
            .mult-edit {
                flex-wrap: wrap;

                .venda-input,
                .troca-input,
                .empresa-input,
                .tabpreco-input {
                    margin-top: 5px;
                    margin-left: 0px !important;
                    width: 100%;
                }

                .add-button {
                    margin-top: 20px;
                    margin-left: 0;
                    width: 100%;
                    flex-direction: row-reverse;

                    button {
                        width: 100%;

                        &:not(:first-child) {
                            margin-left: 0;
                        }
                    }

                    button ~ button {
                        margin-right: $padding;
                    }
                }
            }
        }
    }

    .nav.nav-tabs {
        display: none;
    }
}
</style>
